module.exports = __webpack_public_path__ + "static/media/star-inactive.70f2008a.svg";